<template>
  <ContentSection>
    <Container>
      <Swiper
        :modules="[SwiperThumbs]"
        :watch-slides-progress="true"
        :breakpoints="thumbsBreakpoints"
        :space-between="20"
        @swiper="setThumbsSwiper"
      >
        <SwiperButton
          direction="prev"
          class="absolute left-4 top-1/2 z-50 flex size-8 items-center justify-center rounded-sm bg-gray-500 text-white"
        />
        <SwiperButton
          direction="next"
          class="absolute right-4 top-1/2 z-50 flex size-8 items-center justify-center rounded-sm bg-gray-500 text-white"
        />
        <SwiperSlide v-for="image in data.images" :key="image.id">
          <AppImage
            :asset="image"
            class="aspect-[682/418] size-full cursor-pointer object-cover"
          />
        </SwiperSlide>
      </Swiper>
    </Container>
  </ContentSection>
</template>

<script lang="ts" setup>
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import type { Swiper as SwiperType } from 'swiper'
import { breakpointsTailwind } from '@vueuse/core'
import type { AssetFragment } from '#gql'

defineProps<{
  data: {
    images: AssetFragment[]
  }
}>()

const thumbsSwiper = ref<SwiperType>()

const setThumbsSwiper = (swiper: SwiperType) => {
  thumbsSwiper.value = swiper
}

const thumbsBreakpoints = {
  0: {
    slidesPerView: 1,
  },
  [breakpointsTailwind.md]: {
    slidesPerView: 1.5,
  },
  [breakpointsTailwind.lg]: {
    slidesPerView: 2.5,
  },
  [breakpointsTailwind.xl]: {
    slidesPerView: 3,
  },
}
</script>
